import { render, staticRenderFns } from "./MonitorDetailArray.vue?vue&type=template&id=35fd7924&"
import script from "./MonitorDetailArray.vue?vue&type=script&lang=js&"
export * from "./MonitorDetailArray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports